import { render, staticRenderFns } from "./NumSettedTable.vue?vue&type=template&id=590a6495&"
import script from "./NumSettedTable.vue?vue&type=script&lang=js&"
export * from "./NumSettedTable.vue?vue&type=script&lang=js&"
import style0 from "./NumSettedTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports